import { render, staticRenderFns } from "./FlightCancel.vue?vue&type=template&id=672e76a6&"
import script from "./FlightCancel.vue?vue&type=script&lang=js&"
export * from "./FlightCancel.vue?vue&type=script&lang=js&"
import style0 from "./FlightCancel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports